export default __webpack_public_path__ + "static/media/bluediamond1.122ce413.jpg";